import "./ButtonTabs.css"
import { _ } from "i18n"
import {Keys} from "i18n/locales/types";

interface ButtonTabsItem {
	key: string | number;
	label: string;
	image?: string | null;
	imageShape?: "default" | "square" | "round";
}

interface ButtonTabsProps {
	items: ButtonTabsItem[];
	showCheck?: boolean;
	active: (string | number)[];
	isMultiple?: boolean;
	isNullable?: boolean;
	onChange?: (keys: (string | number)[]) => void;
}

function ButtonTabs({ items, active, showCheck, onChange, isMultiple = false }: ButtonTabsProps) {
	const selectedKeys = isMultiple ? active : active.slice(0, 1);
	const current = new Set(selectedKeys);

	const handleChange = (key: string | number) => {
		let nextKeys: (string | number)[];
		if (isMultiple) {
			const nextSelection = new Set(current);
			if (nextSelection.has(key)) {
				nextSelection.delete(key);
			} else {
				nextSelection.add(key);
			}
			if (nextSelection.size === 0) {
				return;
			}
			nextKeys = Array.from(nextSelection.values());
		} else {
			nextKeys = [key];
		}

		onChange?.(nextKeys);
	}

    return (
        <div className="button-tabs">
			{items.map((item) => {
				const hasImage = item.image != null && item.image !== "";
				const isCurrent = current.has(item.key);
				const checkVisible = isCurrent && showCheck && hasImage === false;

				return (
					<div
						key={item.key}
						className={`button-tabs__item ${isCurrent ? 'is-current' : ''} ${checkVisible ? 'has-check' : ''} ${hasImage ? 'has-image' : ''}`}
						onClick={() => handleChange(item.key)}
					>
						{checkVisible && <span className="icon icon-check icon-white icon-12" />}
						{item.image && <img src={item.image} alt={item.label} className={`button-tabs__item__image button-tabs__item__image--${item.imageShape || "default"}`} />}
						<span>{_(item.label as keyof Keys)}</span>
					</div>
				)}
			)}
		</div>
	)
}

export {ButtonTabs, type ButtonTabsItem};
